import {useEffect, useState} from "react"

export const useTableConfig = ({rowsData, columns}) => {

    const [rows, setRows] = useState(rowsData)
    const [originalRows] = useState(rowsData)
    const [isEditing, setIsEditing] = useState(false)
    const [editingRows, setEditingRows] = useState()
    const [editingColumns, setEditColumns] = useState([])
    const [editedRows, setEditedRows] = useState()
    const [leftColumns, setLeftColumns] = useState([]);

    useEffect(() => {
        setEditingRows(rows.filter(e => e.type !== 'step').map(e => e.id))
        setEditColumns(columns.map(c => {
            return {columnName: c.name, editingEnabled: c.editable}
        }))
    }, [])

    const changeColumns = (columnName) => {
        if (leftColumns.includes(columnName)) {
            setLeftColumns(leftColumns.filter(x => x !== columnName))
        } else {
            setLeftColumns([...leftColumns, columnName])
        }
    }

    const [tableColumnExtensions] = useState([
        {columnName: 'acc_description_edit', width: 350},
        {columnName: 'acc_description', width: 350},
        {columnName: 'priorY', width: 200},
        {columnName: 'priorM', width: 200},
        {columnName: 'actual', width: 200},
        {columnName: 'rf_n', width: 200},
        {columnName: 'filename', align: 'left'},
        {columnName: 'download', width: 300, align: 'center'},
        {columnName: 'url_produto', width: 800, align: 'center'},
        {columnName: 'url', width: 800, align: 'center'},
        {columnName: 'url_courier', width: 150, align: 'center'},
        {columnName: 'url_prazos', width: 150, align: 'center'},
        /*{ columnName: 'budget', align: 'right', width: 150 },*/
    ]);

    const getChildRows = (row, rootRows) => {
        const childRows = rootRows.filter(r => r.parentId === (row ? row.id : null));
        return childRows.length ? childRows : null;
    };

    const getRowId = row => row.id;

    const commitChanges = ({changed}) => {
        let changedRows;

        if (changed) {
            changedRows = rows.map(row => (changed[row.id] ? {...row, ...changed[row.id]} : row));
        }
        setRows(changedRows);
    };

    const undoChanges = () => setRows(originalRows)


    return {
        setIsEditing,
        isEditing,
        tableColumnExtensions,
        getChildRows,
        rows,
        commitChanges,
        getRowId,
        leftColumns,
        changeColumns,
        editedRows,
        setEditedRows,
        editingRows,
        editingColumns,
        setEditingRows,
        undoChanges
    }
}
